import transform from './transform/index';
import process from './process/index';
import { DigitImageData } from './digit-image-data';

const digit = {
  transform,
  process,
  DigitImageData,
}

export default digit;
